/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/shared/global/adobeLaunch.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'Fandango/adobeLaunch', exports: {} }; const exports = module.exports;

const EventTypes = {
    EMAIL_CHANGE_COMPLETE: 'change email complete',
    EMAIL_CHANGE_ERROR: 'change email error',
    GENERIC_CLICKS: 'generic clicks',
    LOYALTY_CLAIM_COMPLETE: 'loyalty claim complete',
    LOYALTY_CLAIM_CONFIRM: 'loyalty claim confirm',
    LOYALTY_CLAIM_STATE: 'loyalty claim state',
    LOYALTY_CODE_PAGE: 'loyalty code page',
    LOYALTY_LEDGER_STATE: 'loyalty ledger state',
    NAME_CHANGE_COMPLETE: 'display name change complete',
    NAME_CHANGE_ERROR: 'display name change error',
    PAGEVIEW: 'pageview',
    PASSWORD_CHANGE_COMPLETE: 'change password complete',
    PASSWORD_CHANGE_ERROR: 'change password error',
    PROGRAM_ADD: 'exhibitor loyalty program add',
    PROGRAM_ADD_ERROR: 'exhibitor loyalty program add error',
    REWARDS_PRODUCT_CLICK: 'rewards product click',
    UA_CAROUSEL_CLICK: 'ua carousel click',
}
function track(data) {
    if (!data || !Array.isArray(window.dataLayer)) {
        return;
    }
    let event;
    if (typeof data === 'string') {
        event = {
            event: data
        };
    }
    else if (typeof data === 'object') {
        event = data;
    }
    else {
        return;
    }
    window.dataLayer.push(event);
}
export default {
    EventTypes,
    track
};